import { render } from "./dashboard_portfolio.vue?vue&type=template&id=fe504366"
import script from "./dashboard_portfolio.vue?vue&type=script&lang=js"
export * from "./dashboard_portfolio.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__